import {CLEAR_DAILY_REPORT, FETCH_DAILY_REPORTS, LIST_DAILY_REPORTS} from "./types";

const init = {
    isLoading: false,
    data: null,
    filter: {},
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_DAILY_REPORTS:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_DAILY_REPORTS:
            return {
                ...state,
                isLoading: false,
                data: payload.data,
                ...payload.paging
            };
        case CLEAR_DAILY_REPORT:
            return {
                ...init
            };
        default:
            return state;
    }
}